"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Link = require("./Link.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Link = /*#__PURE__*/_react.default.forwardRef(({
  text,
  href,
  type,
  className,
  ...props
}, ref) => {
  return /*#__PURE__*/_react.default.createElement(_Link.StyledLink, _extends({
    "data-testid": "link"
  }, props, {
    href: href,
    ref: ref,
    className: (0, _classnames.default)({
      [type]: type
    }, className)
  }), text);
});

exports.Link = Link;
Link.defaultProps = {
  type: 'primary'
};
Link.propTypes = {
  text: _propTypes.default.string.isRequired,
  href: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  className: _propTypes.default.string
};